import type {CreditUsage} from '@/client/mentor/CreditUsageClient'
import type {Message} from '@/client/mentor/MessagesClient'
import type {InjectionKey, Ref} from 'vue'

export type AssistantChatMessageContext = {
  companyId?: Ref<number | undefined>
  creditUsage: Ref<CreditUsage | undefined>
  isMobileVersion: Ref<boolean>
  getPrintSenderLabel: (message: Message) => string
  getPrintTimestamp: (message: Message) => string
  getToggleVisible: (messageId: number, toggleKey: string) => boolean | undefined
  getOrInitToggleVisible: (messageId: number, toggleKey: string, defaultVisible: boolean) => boolean
  setToggleVisible: (messageId: number, toggleKey: string, visible: boolean) => void
}

export const assistantChatMessageContextKey: InjectionKey<AssistantChatMessageContext> = Symbol('assistant-chat-message-context')
